import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { BookingReason } from "@app/models/rest/booking-reason";
import { BookingReasonRestService } from "@app/services/hal/booking-reason-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class BookingReasonStore extends RealTimeDataStore<BookingReason> {
  constructor() {
    const bookingReasonRestService = inject(BookingReasonRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(bookingReasonRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("BookingReason");
  }
}
